import { createFileRoute } from "@tanstack/react-router"
import { MetersOverviewReport } from "@/features/reports/components/MetersOverviewReport"
import {
  applyMetersOverviewDefaults,
  metersOverviewQuery,
  MetersOverviewSearchParams,
} from "@/features/reports/core/hooks/useMetersOverviewReport"

export const Route = createFileRoute("/(authenticated)/reports/meters-overview")({
  validateSearch: MetersOverviewSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps: search }) => {
    void context.queryClient.ensureQueryData(
      metersOverviewQuery(applyMetersOverviewDefaults(search)),
    )
  },
  component: MetersOverviewReport,
})
